import styled from 'styled-components/macro';
import Select from "./select";
import {themecolors} from "../utils/themecolors";

const MultichoiceField = styled(({className, id, label, value, onChange, options}) => {
    return (
        <div className={className}>
            {label && <label htmlFor={id} dangerouslySetInnerHTML={{__html: label}} />}
            <Select id={id} value={value} onChange={onChange}>
                {options.map(({value, label}) => <option key={value} value={value}>{label}</option>)}
            </Select>
        </div>
    );
})`
  display: flex;
  flex-direction: column;

  label {
    margin-top: 10px;
    font-size: 14px;
    margin-bottom: 8px;
  }

  label:first-of-type {
    margin-top: 0;
  }
  
  select {
    border: ${({theme}) => theme.color.name === 'dark' ? `1px solid ${theme.dark_border}` : theme.standard_border};
    background-color: ${({theme}) => theme.color.name === 'dark' ? theme.dark_field : themecolors.pure_white};
    color: ${({theme}) => theme.control.color};
  }
`;

export default MultichoiceField;
